module.exports = __webpack_public_path__ + "img/cerrar.18e3e70e.svg";